<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="名称" prop="diseaseName">
                <a-input v-model="queryParam.diseaseName" placeholder="请输入疾病名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="类型" prop="type">
               <a-select v-model="queryParam.type">
                 <a-select-option v-for="item in typeList" :value="item.id">{{item.name}}</a-select-option>
               </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="常见病症" prop="isCommon">
                <a-select v-model="queryParam.isCommon" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['disease:disease:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['disease:disease:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['disease:disease:remove']">
          <a-icon type="delete" />删除
        </a-button>

        <a-button type="primary" @click="handleImport" v-hasPermi="['disease:disease:import']">
          <a-icon type="upload" />导入
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['disease:disease:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-modal
        title="导入"
        :visible="openUpload"
        :maskClosable="false"
        :confirm-loading="uploading"
        @cancel="importExcelHandleCancel"
        @ok="importExcelHandleChange"
      >
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
            <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
          </a-upload-dragger>
          <!-- <a-checkbox @change="handleCheckedUpdateSupport" :checked="updateSupport != 0">
            是否更新已经存在的数据
          </a-checkbox> -->
          <a @click="importTemplate">下载模板</a>
        </a-spin>
      </a-modal>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['disease:disease:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['disease:disease:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['disease:disease:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDisease,listDisease, delDisease,importDisease } from '@/api/disease/disease'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from "moment";
import {listType} from "@/api/disease/type";

export default {
  name: 'Disease',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      // 非单个禁用
      fileList: [],
      typeList:[],
      // 非单个禁用
      single: true,
      uploading:false,
      openUpload: false,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        diseaseName: null,
        isCommon: null,
        type: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '编号',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '名称',
          dataIndex: 'diseaseName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '常见病种',
          dataIndex: 'isCommon',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text === 0 ? '否' : '是'
          }
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getTypeList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getTypeList() {
      listType().then(res => {
        this.typeList = res.data
      })
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },

    importTemplate() {
      this.download(
        "disease/disease/importTemplate",
        {},
        `disease_${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );
    },

    importExcelHandleChange() {
      this.uploading = true
      const {fileList} = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      importDisease(formData)
        .then((response) => {
          if (response.success) {
            this.fileList = []
            this.$message.success(response.message)
            this.logisOpen = false
            this.$emit('ok', response.data)
            this.getList()
          } else {
            this.$message.error(response.message)
            return
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },

    handleImport() {
      this.title = "导入";
      this.openUpload = true;
    },

    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    importExcelHandleCancel(e) {
      this.openUpload = false
      this.fileList = []
      // 关闭后刷新列表
      this.$emit('ok')
    },


    /** 查询病种信息列表 */
    getList () {
      this.loading = true
     pageDisease(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        diseaseName: undefined,
        isCommon: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDisease(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('disease/disease/export', {
            ...that.queryParam
          }, `病种信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
